const dev = {
    s3: {
        REGION: "eu-west-1",
        BUCKET: "innovation-unboxed-api-dev-auditdatabucket-2vfgpu8v8g4b"
    },
    apiGateway: {
        REGION: "eu-west-1",
        URL: "https://mci3dcagi4.execute-api.eu-west-1.amazonaws.com/dev"
    },
    cognito: {
        REGION: "eu-west-1",
        USER_POOL_ID: "eu-west-1_tUWdR4vMb",
        APP_CLIENT_ID: "3rc4rvus0sg7pc5ffcifnpp8o3",
        IDENTITY_POOL_ID: "eu-west-1:ce4df954-b775-41dc-9f24-42268b80f22d"
    }
};

const prod = {
    s3: {
        REGION: "eu-west-1",
        BUCKET: "innovation-unboxed-api-prod-auditdatabucket-fk1bqk4tg4ek"
    },
    apiGateway: {
        REGION: "eu-west-1",
        URL: "https://2swp18lpg5.execute-api.eu-west-1.amazonaws.com/prod"
    },
    cognito: {
        REGION: "eu-west-1",
        USER_POOL_ID: "eu-west-1_LJFdECv4X",
        APP_CLIENT_ID: "6v69u3gnaovvcljdeq4a7tlhh4",
        IDENTITY_POOL_ID: "eu-west-1:a10eab50-4fc7-46cc-ad1b-1ed38a762423"
    }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : dev;

export default {
    // Add common config values here
    ...config
};


